import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { AxiosError } from 'axios'
import { CreateUserAliasBody } from '@/types'
import { removeNonNumeric } from '@/helpers'

export async function createUserAlias(body: CreateUserAliasBody) {
  const response = await httpClient('user-manager').post(
    '/v1/user/me/alias',
    {
      ...body,
      data: body.type === 'phone' ? removeNonNumeric(body.data) : body.data,
    },
  )

  return response.data
}

export function useCreateUserAlias(
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    CreateUserAliasBody,
    unknown
  >,
) {
  return useMutation({
    mutationFn: createUserAlias,
    ...options,
  })
}
